'use client'
import React, { useContext, useState } from 'react';
import {Button, FormControl, FormErrorMessage, Input} from '@chakra-ui/react';
import {Box, Divider, Flex} from '@chakra-ui/layout';
import {Text} from '@chakra-ui/layout';
import { useForm } from 'react-hook-form';
import GoogleIcon from './googleIcon';
import { AuthContext } from '../lib/authContext';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import useTranslation from '../../lib/i18n/useTranslation';
import { trackUmamiEvent } from '../../lib/analytics/umami';
import { openInExternalBrowser } from '../lib/inAppBrowser';
export default function SignInForm() {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [globalError, setGlobalError] = useState(null);
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect_url');
  const arg = searchParams.get('arg');
  const { t } = useTranslation();
  const openInBrowser = () => {
    openInExternalBrowser(window.location.href);
  };
   const {
    handleSubmit,
    control,
    register,
    getValues,
    formState: { isSubmitting, isDirty, isValid, errors }
  } = useForm({ mode: 'onBlur'});
  const signInWithGoogle = async () => {
    trackUmamiEvent('auth_signin_google_clicked');
    try {
      authContext.signInWithGoogle();
    } catch (e) {
      trackUmamiEvent('auth_signin_google_failed', { message: e.message });
      setGlobalError(e.message);
      console.error(e);
    }
  };
  const onSubmit = async (data) => {
    trackUmamiEvent('auth_signin_submitted');
    try {
      await authContext.signIn(data.email, data.password);
      trackUmamiEvent('auth_signin_success');
    } catch (e) {
      trackUmamiEvent('auth_signin_failed', { message: e.message });
      setGlobalError(e.message);
      console.error(e);
    }
  };
  const goToPasswordReset = () => {
    const email = getValues('email');
    if(email) {
      navigate('/auth/reset-password' + '?email=' + email)
    } else {
      navigate('/auth/reset-password')
    }
  }
  return (
    <>
      <Flex
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        w="100%"
        >
        <Flex
          as='form'
          w='100%'
          flexDirection={'column'}
          alignItems={'center'}
          onSubmit={handleSubmit(onSubmit)} >
          <FormControl isInvalid={errors.email} mb={2}>
              <Input
                placeholder={t('auth.email')}
                {...register('email', {
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: t('auth.invalidEmail')
                  }
                })}
              />
              <FormErrorMessage color="text.medium.red">{errors.email?.message}</FormErrorMessage>
            </FormControl>
          <FormControl isInvalid={errors.password} mb={1}>
              <Input
                placeholder={t('auth.password')}
                type="password"
                {...register('password', {
                  required: true
                })}
              />
              <FormErrorMessage color="text.medium.red">{errors.password?.message}</FormErrorMessage>
            </FormControl>
            {globalError && (
            <Box mb={3}>
              <Text color={'text.medium.red'}>{globalError}</Text>
            </Box>
          )}
          <Flex mb={3} justifyContent={'center'}>
            <Button
              textAlign={'center'}
              variant="coralTransparent"
              onClick={goToPasswordReset}>
              {t('auth.forgotPassword')}
            </Button>
          </Flex>
          <Flex
            justifyContent={'center'}
            flexDirection={'column'}
            alignItems={'center'}
          > 
            <Button
              w="120px"
              type={'submit'}
              variant="coralFill"
              isLoading={isSubmitting}
              isDisabled={!isValid}
              mb={3}
            >{t('auth.signIn')}</Button>
            {!authContext.isInAppBrowser && (
              <Button
                onClick={signInWithGoogle}
                variant="greyOutline"
                leftIcon={<GoogleIcon />} >
                {t('auth.signInWithGoogle')}
              </Button>
            )}
            {authContext.isInAppBrowser && (
              <Flex mt={3} maxW="280px" alignItems="center" flexDirection="column">
                <Text textAlign="center" fontSize="12px" color="text.medium.grey">
                  {t('auth.googleInAppBrowserBlocked')}
                </Text>
                <Button mt={2} variant="coralTransparent" onClick={openInBrowser}>
                  {t('auth.openInBrowser')}
                </Button>
              </Flex>
            )}
          </Flex>
          <Divider mt={3} />
          <Link to={"/auth/sign-up" + (redirectUrl ? '?redirect_url=' + redirectUrl : '') + (arg ? '&arg=' + arg : '')}>
              <Button
                variant="coralTransparent"
                mt={3}
                textAlign={'center'}
              >
              {t('auth.newHereSignUp')}
            </Button>
          </Link>
        </Flex>
      </Flex>
    </>
  );
}
